<template>
  <!-- //NOSONAR -->
    <li class="carousel-slide" :inert="!visible" :style="{ padding: `0 ${this.padding}px` }">
      <div class="carousel-slide__content">
        <slot />
      </div>
    </li>
</template>

<script>
  export default {
    name: 'slide',
    data() {
      return {
        padding: this.$parent.slidePadding,
        observer: null,
        visible: true,
      };
    },
    mounted() {
      this.observer = new IntersectionObserver(
        (changes) => {
          changes.forEach((change) => {
            this.visible = change.isIntersecting;
          });
        },
        {
          threshold: [0.006],
        }
      );

      this.observer.observe(this.$el);
    },
    beforeDestroy() {
      this.observer.unobserve(this.$el);
    },
  };
</script>

<style>
.carousel-slide__content {
  user-select: none;
  overflow: hidden;
  display: flex;
  align-items: center;
  flex-basis: inherit;
}
</style>
